import { useQuery, useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { customApi } from "../../../../CustomHoock/CustomApi";
import { getOrderTotalR } from "../../../../General/Store/GeneralSlice";
let cacheTime = 5 * 60 * 1000;
let staleTime = 10 * 60 * 1000;
const useGetArchiveOrders = (reqUnitsBody) => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(
    ["GetArchiveOrders", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/OrderArchive/GetAllOrder",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),

    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      onSuccess: () => {
        dispatch(getOrderTotalR(totalRecord));
      },
      select: (data) => {
        totalRecord = data?.data.totalRecord;
        let res = data?.data.data;
        return res;
      },
    },
  );
};
/* ----------------------------- BetterCustomer ----------------------------- */
const useGetCustomerOrderCountChart = () => {
  return useMutation(["GetCustomerOrderCountChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetCustomerOrderCountChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
const useGetCustomerOrderRegisterCountChart = () => {
  return useMutation(["GetCustomerOrderRegisterCountChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetCustomerOrderRegisterCountChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};
const useGetCustomerOrderAreaChart = () => {
  return useMutation(["GetCustomerOrderRegisterAreaChart"], (body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetCustomerOrderAreaChart",
      reactQuery: "query",
      requestBody: body,
    }),
  );
};

const useGetOrderCountChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderCountChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetOrderAreaChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderAreaChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};

const useGetOrderRegisterCount = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderRegisterCountChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};

const useGetPlateAreaChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetPlateAreaChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetDamagePlate = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetPlateDamageAreaChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetOrderDamageAreaChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderDamageAreaChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetFinancialTransactionChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetFinancialTransactionChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetChequeChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetChequeChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetBankAccountTransferChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetBankAccountTransferChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
/* -------------------------------- Designer -------------------------------- */
const useGetDesignerOrderRegisterCountChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetDesignerOrderRegisterCountChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetDesignerOrderCountChartForAdmin = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetDesignerOrderCountChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetDesignerOrderAreaChartForAdmin = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetDesignerOrderAreaChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
/*================== GetAllKlischeType And Thicnes =================*/
const useGetGetAllKlischeType = () => {
  return useQuery(
    "GetAllKlischeType",
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/Dashboard/GetAllKlischeType",
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    },
  );
};
const useGetAllKlischeThikness = (klischeTypeId) => {
  return useQuery(
    ["GetAllKlischeThikness", klischeTypeId],
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/Dashboard/GetAllKlischeThikness?klischeTypeId=${klischeTypeId}`,
        reactQuery: "query",
      }),
    {
      enabled: !!klischeTypeId,
      refetchOnWindowFocus: false,
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    },
  );
};
const useGetAvrageKlischePrice = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetAvrageKlischePrice",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetAvrageKlischeArea = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetAvrageKlischeArea",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetKlischePrice = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetKlischePrice",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
/*================== Person Cartable Chart =================*/
export const useGetOrderCountChartForDesigner = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderCountChartForDesigner",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetOrderRegisterCountChartForDesigner = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderRegisterCountChartForDesigner",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetOrderAreaChartForDesigner = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetOrderAreaChartForDesigner",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
const useGetLeaveCounts = (personId) => {
  return useQuery(
    ["GetLeaveCounts", personId],
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/Dashboard/GetLeaveCounts?personId=${personId}`,
        reactQuery: "query",
      }),

    {
      enabled: !!personId,
      refetchOnWindowFocus: false,

      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    },
  );
};
const useGetLeaveCountForm = () => {
  return useMutation(
    (personId) =>
      customApi({
        apiType: "get",
        url: `/api/v1/Dashboard/GetLeaveCounts?personId=${personId}`,
        reactQuery: "mutate",
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetOrderCountChartForCustomer = () => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/Dashboard/GetOrderCountChartForCustomer`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetOrderRegisterCountChartForCustomer = () => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/Dashboard/GetOrderRegisterCountChartForCustomer`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetOrderAreaChartForCustomer = () => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/Dashboard/GetOrderAreaChartForCustomer`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetYearsDropdown = () => {
  return useQuery(
    ["GetYearsDropdown"],
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/Dashboard/GetYearsDropdown`,
        reactQuery: "query",
      }),

    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      select: (data) => {
        return data?.data.data;
      },
    },
  );
};
const useGetMonthsDropdown = () => {
  return useQuery(
    ["GetMonthsDropdown"],
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/Dashboard/GetMonthsDropdown`,
        reactQuery: "query",
      }),

    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      select: (data) => {
        return data?.data.data;
      },
    },
  );
};

const useGetOrderCompareCountChart = () => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/Dashboard/GetOrderCompareCountChart`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetOrderCompareAreaChart = () => {
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: `/api/v1/Dashboard/GetOrderCompareAreaChart`,
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    },
  );
};
const useGetInvoicePriceChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetInvoicePriceChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export const useGetHourlyOrderRegisterCountChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetHourlyStepCountChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
/* ------------------------------- salesExpert ------------------------------ */
export const useGetSalesExpertInvoicePriceChart = () => {
  return useMutation((body) =>
    customApi({
      apiType: "post",
      url: "/api/v1/Dashboard/GetSalesExpertInvoicePriceChart",
      reactQuery: "mutate",
      requestBody: body,
    }),
  );
};
export {
  useGetArchiveOrders,
  useGetCustomerOrderRegisterCountChart,
  useGetOrderCountChart,
  useGetDesignerOrderRegisterCountChart,
  useGetPlateAreaChart,
  useGetCustomerOrderAreaChart,
  useGetOrderAreaChart,
  useGetAllKlischeThikness,
  useGetGetAllKlischeType,
  useGetAvrageKlischePrice,
  useGetAvrageKlischeArea,
  useGetKlischePrice,
  useGetLeaveCounts,
  useGetLeaveCountForm,
  useGetDamagePlate,
  useGetOrderCountChartForCustomer,
  useGetOrderRegisterCountChartForCustomer,
  useGetOrderAreaChartForCustomer,
  useGetYearsDropdown,
  useGetMonthsDropdown,
  useGetOrderCompareCountChart,
  useGetOrderCompareAreaChart,
  useGetOrderRegisterCount,
  useGetInvoicePriceChart,
  useGetCustomerOrderCountChart,
  useGetDesignerOrderAreaChartForAdmin,
  useGetDesignerOrderCountChartForAdmin,
};
